import DOMPurify from "dompurify";

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c] as string));
}

/**
 * A contract's text as SAFE HTML.
 *
 * The stored content may be an HTML string, `{html}` or `{text}`. Whatever the
 * shape, the result keeps paragraphs, line breaks and lists and is passed
 * through DOMPurify, because it is written by an operator and rendered in a
 * client's browser. Plain-text line breaks become `<br>`. `null` when there is
 * no text to show.
 */
export function contentHtml(content: unknown): string | null {
  let raw: string | null = null;
  let isHtml = false;
  if (typeof content === "string") {
    raw = content;
    isHtml = /<[a-z][\s\S]*>/i.test(content);
  } else if (content && typeof content === "object") {
    const o = content as { html?: unknown; text?: unknown };
    if (typeof o.html === "string") { raw = o.html; isHtml = true; }
    else if (typeof o.text === "string") { raw = o.text; isHtml = false; }
  }
  if (!raw || !raw.trim()) return null;
  const html = isHtml ? raw : escapeHtml(raw).replace(/\r?\n/g, "<br>");
  return DOMPurify.sanitize(html, { FORBID_TAGS: ["style", "script"], FORBID_ATTR: ["style"] });
}
